module.exports = __webpack_public_path__ + "img/empty.1cd2fbdf.png";